// extracted by mini-css-extract-plugin
export default {"container":"RecipeSteps_container__gQlbz","loading":"RecipeSteps_loading__5JKaS","notFound":"RecipeSteps_notFound__l5Dhw"};